import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { CONTRACT_ADDRESS } from "../config";

export const CopyCA = ({ testId = "copy-ca", className = "" }) => {
  const [copied, setCopied] = useState(false);
  const short = `${CONTRACT_ADDRESS.slice(0, 6)}…${CONTRACT_ADDRESS.slice(-4)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {}
  };

  return (
    <button
      onClick={copy}
      data-testid={testId}
      title={CONTRACT_ADDRESS}
      className={`group flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] transition-colors hover:text-pulse-soft ${className}`}
    >
      <span className="text-fog-600">CA</span>
      <span className="text-fog-100">{copied ? "Copied" : short}</span>
      {copied ? (
        <Check className="h-3 w-3 text-pulse-soft" />
      ) : (
        <Copy className="h-3 w-3 text-fog-600 transition-colors group-hover:text-pulse-soft" />
      )}
    </button>
  );
};
